import * as Yup from 'yup';

export const schema = Yup.object({
    endDate: Yup.date().nullable(),
    amount: Yup.number().nullable(),
    startDate: Yup.date().nullable(),
    status: Yup.object()
        .shape({
            value: Yup.string().required('Status value is required'),
            label: Yup.string().required('Status label is required'),
        })
        .nullable(),
    marketplace: Yup.object()
        .shape({
            value: Yup.string().required('Marketplace value is required'),
            label: Yup.string().required('Marketplace label is required'),
        })
        .nullable(),
    type: Yup.object()
        .shape({
            value: Yup.string().required('Type value is required'),
            label: Yup.string().required('Type label is required'),
        })
        .nullable(),
});

export const initialValues = {
    startDate: null,
    endDate: null,
    amount: '',
    status: { label: 'All', value: 'all' },
    type: { label: 'All', value: 'all' },
    marketplace: { label: 'All', value: 'all' },
};
